export default "__VITE_PUBLIC_ASSET__56d0ae70__"